module.exports = __webpack_public_path__ + "img/02.8506c07f.png";